// extracted by css-extract-rspack-plugin
export default {"centered":"gI4tYv","unsubscribe-width":"Vgk_EB","unsubscribeWidth":"Vgk_EB"};